<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col lg="12" sm="12" class="form-for-textarea">
                        <b-overlay :show="unitLoad">
                            <b-table-simple striped bordered small>
                                <tr class="bg-light">
                                    <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                    <th>{{ $t('production_store.pro_category') }}</th>
                                    <th>{{ $t('production_store.pro_sub_category') }}</th>
                                    <th>{{ $t('production_store.pro_name') }}</th>
                                    <th>{{ $t('production_store.pro_unit') }}</th>
                                    <th>{{ $t('production_store.quantity') }}</th>
                                    <th>{{ $t('production_store.approve_quantity') }}</th>
                                    <th>{{ $t('production_store.reason') }}</th>
                                </tr>
                                <tr v-for="(item, index) in dataArray.requisition_details" :key="index">
                                    <td>{{ $n(index + 1) }}</td>
                                    <td>{{ productCategoryById(item.category_id) }}</td>
                                    <td v-if="item.sub_category_id">{{ productSubCategoryById(item.sub_category_id) }}</td>
                                    <td v-else></td>
                                    <td>{{ productNameById(item.product_id) }}</td>
                                    <td>{{ unitNameById(item.unit_id) }}</td>
                                    <td>{{ $n(item.req_quantity) }}</td>
                                    <td>{{ $n(item.approve_quantity) }}</td>
                                    <td v-if="currentLocale === 'en'">{{ item.reason }}</td>
                                    <td v-else>{{ item.reason_bn }}</td>
                                </tr>
                            </b-table-simple>
                        </b-overlay>
                        <div v-if="dataArray.status === 2">
                            <h5 class="mb-3" style="border-bottom: 1px solid #ddd"> {{ $t('production_store.forward') + ' ' + $t('production_store.details') }}</h5>
                            <b-row v-for="(item, index) in dataArray.requisition_forwards" :key="index">
                                <b-col>
                                    <b-overlay :show="unitLoad">
                                        <b-table-simple striped bordered small>
                                            <tr class="bg-light">
                                                <th>{{ $t('production_store.comment') }}</th>
                                                <th>{{ $t('production_store.commented_by') }}</th>
                                                <th>{{ $t('production_store.designation') }}</th>
                                            </tr>
                                            <tr>
                                                <td >{{ currentLocale == 'en' ? item.note : item.note_bn }}</td>
                                                <td>{{ getName(item.sender_id) }}</td>
                                                <td>{{ designation }}</td>
                                            </tr>
                                        </b-table-simple>
                                    </b-overlay>
                                </b-col>
                                <hr>
                            </b-row>
                        </div>
                    </b-col>
                    <div class="col text-right">
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                    </div>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'FormLayout',
    props: ['id', 'userList'],
    components: {
    },
    data () {
        return {
            saveBtnName: this.$t('globalTrans.save'),
            dataArray: {
            },
            designation: '',
            unitLoad: false
        }
    },
    created () {
      if (this.id) {
          const tmp = this.getRequisitionInfoData(this.id)
          this.dataArray = tmp
      }
    },
    watch: {
    },
    mounted () {
    },
    computed: {
        currentLocale: function () {
            return this.$i18n.locale
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    methods: {
        getRequisitionInfoData (id) {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            return JSON.parse(JSON.stringify(tmpData))
        },
        getName (id) {
            const idd = parseInt(id)
            const user = this.userList.find(user => user.value === idd)
            this.designation = this.getDesignation(user.designation_id)
            if (this.$i18n.locale === 'bn') {
                return user.text_bn
            } else {
                return user.text_en
            }
        },
        getDesignation (id) {
            const Designation = this.$store.state.commonObj.designationList.find(designation => designation.value === id)
            if (this.$i18n.locale === 'bn') {
                return Designation.text_bn
            } else {
                return Designation.text_en
            }
        },
        productCategoryById (id) {
            const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        productNameById (id) {
            const product = this.productCommonObj.productList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
               return product.text_en
            }
        },
        unitNameById (id) {
            const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text_bn
            } else {
               return unit.text_en
            }
        }
    }
}
</script>
